// Per-project branding. Put the image files in /public and update these values.
export const APP_NAME = 'Material Cost Control';
export const APP_SUBTITLE = 'Management System';
export const APP_LOGO = '/assets/images/renaissance-logo.png';
export const APP_FAVICON = '/favicon.ico';
export const APP_POWERED_BY = 'Powered by Your Company';
